/**
 * @Des 组件 室外 首页
 * @Description
 * @Author 
 * @Date 2023/11/26
 */
/* HTML */
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" v-if="false">
			<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
			<div class="router-title-tit"></div>
		</div>
		<!-- router-title-box end -->
		<HomePage ref="HomePage" />
	</div>
</template>

/* JS */
<script>
	// 引入组件 室外 首页
	import HomePage from '@/components_outdoor/Home/HomePage';
	
	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2023/11/26
		 */
		name: 'Home',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2023/11/26
		 */
		components: {
			// 组件 室外 首页
			HomePage,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2023/11/26
		 */
		props: {
			
		},
        
		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2023/11/26
		 */
		created() {
			
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2023/11/26
		 */
		mounted() {
			// body class
			document.getElementsByTagName('body')[0].className = 'home-page-view';
		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2023/11/26
		 */
		beforeDestroy() {
			// body class
			document.getElementsByTagName('body')[0].className = 'home-page-view';
		},
		
		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2023/11/26
		 */
		data() {
			return {
				
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2023/11/26
		 */
		methods: {
			/**
			 * @Des 关闭路由 
			 * @Auth
			 * @Date 2023/11/26
			 */
			closeRouter () {
				// 跳转到 首页
				this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
	}// export default
</script>

/* CSS */
<style src="@/static_dazzle/css/home/home.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
	.router-title-box {
		position: absolute;
	}
</style>


// WEBPACK FOOTER //
// src/views/system-outdoor/home/Home.vue